import { useCallback, useLayoutEffect } from 'react';
import { throttle } from 'throttle-debounce';

import { usePlayingState } from '@/scenarios/legacy-player/hooks/usePlayingState';
import { PlayingState } from '@/scenarios/legacy-player/types/instance';

import { useSessionStopped } from './useSessionStopped/useSessionStopped';

const DEBOUNCE = 1000;

export const useActivityTracker = ({
    sessionStopped,
    reset,
}: ReturnType<typeof useSessionStopped>) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleReset = useCallback(
        throttle(DEBOUNCE, true, () => {
            if (!sessionStopped) {
                reset();
            }
        }),
        [reset, sessionStopped]
    );

    const { playingState, previousPlayingState } = usePlayingState();

    useLayoutEffect(() => {
        if (playingState === PlayingState.play && previousPlayingState === PlayingState.pause) {
            handleReset();
        }
    }, [playingState, previousPlayingState, handleReset]);
};
